import BreakpointDemo from './BreakpointDemo'

export default BreakpointDemo
// eslint-disable-next-line import/export
export * from './BreakpointDemo'
